module.exports = "<div class=\"grid-control component-date-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition }} <p class=info>被修改条件限制</p> {{else}} <input type=text class=\"ui-calendar ui-width dynamic-form-input date_yy-mm-dd\" style=color:#999 value={{value}} /> <span id=errorMessage></span> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/dataGrid/data-table-toolbar/grid-data-control/grid-data-control.html
// module id = 2021
// module chunks = 50